import { useQuery } from "@tanstack/react-query";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "";

function getAuthHeaders() {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export function useObservationDisplayCodes(ids: string[]) {
  const sortedKey = [...ids].sort().join(",");

  const { data, isLoading } = useQuery<Record<string, string>>({
    queryKey: ["observation-display-codes", sortedKey],
    queryFn: async () => {
      if (ids.length === 0) return {};
      const response = await axios.get(
        `${API_BASE_URL}/api/observation-display-codes`,
        {
          params: { ids: ids.join(",") },
          headers: getAuthHeaders(),
        }
      );
      return response.data?.data ?? {};
    },
    enabled: ids.length > 0,
    staleTime: 5 * 60_000,
  });

  return {
    displayCodes: data ?? {},
    isLoading,
  };
}
